// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"7c67b8ea","314":"a92bb21f","478":"0b10cb04","704":"17c882e3","759":"5896cd9c","828":"c60db185","845":"18b8cfd2"}[chunkId] + ".chunk.js";
};